/**
 * Cash concentration (FSD 3.2.1, FIN-T01-R020): sweep structures, simulation,
 * execution, deferrals and history, on one screen.
 *
 * Gated on `treasury.sweep.read`, which every GET route of the feature declares; each
 * write is further gated in the screen on `treasury.sweep.manage` / `.execute`.
 *
 * The wiring packet spreads `TREASURY_CONCENTRATION_ROUTES` beside `TREASURY_ROUTES` and
 * adds the `treasury-concentration` nav item (p03, fsd 3.2.1, code R020, label key
 * `treasury.routeTitles.concentration`).
 */

import type { RouteRecordRaw } from 'vue-router'

import { SWEEP_PERMISSIONS } from '@/modules/treasury/concentration/permissions'

export const TREASURY_CONCENTRATION_PATH = '/treasury/concentration'

export const SWEEP_PATHS = {
  register: TREASURY_CONCENTRATION_PATH,
  structure: (id: number) => `${TREASURY_CONCENTRATION_PATH}?structure=${id}`,
  simulation: (structureId: number, simulationId: number) =>
    `${TREASURY_CONCENTRATION_PATH}?structure=${structureId}&simulation=${simulationId}`,
} as const

export const TREASURY_CONCENTRATION_ROUTES: RouteRecordRaw[] = [
  {
    path: TREASURY_CONCENTRATION_PATH,
    name: 'treasury-concentration',
    component: () => import('@/modules/treasury/concentration/ConcentrationView.vue'),
    meta: {
      titleKey: 'treasury.routeTitles.concentration',
      permission: SWEEP_PERMISSIONS.read,
    },
  },
]
